/**
 * 차량 카탈로그에서 화면 문구를 만드는 곳.
 *
 * 카탈로그에는 사실만 둡니다(연도 숫자, 차급 문구). 그것을 어떻게 이어 붙여
 * 보여 줄지는 화면의 문제라서 여기 모읍니다. 헤더와 옵션 패널이 같은 부제를
 * 보여 주는데, 이어 붙이는 규칙을 양쪽에 적어 두면 한쪽만 고쳐질 수 있습니다.
 */
import type { CarModel, ProductionYears } from '../types';

/**
 * 생산 기간 표기.
 *
 * 아직 생산 중이면 뒤쪽을 비웁니다(`2019-`). "현재"나 "present" 같은 말을 넣지
 * 않는 이유는, 그 문구가 박히면 생산이 끝난 뒤에도 계속 현재라고 주장하기
 * 때문입니다. 비어 있으면 적어도 틀린 말은 하지 않습니다.
 */
export function formatProductionYears(years: ProductionYears): string {
  return `${years.start}-${years.end ?? ''}`;
}

/** 헤더와 옵션 패널이 함께 쓰는 부제. "생산 기간 · 차급" 형태입니다. */
export function formatModelSubtitle(model: Pick<CarModel, 'productionYears' | 'category'>): string {
  return `${formatProductionYears(model.productionYears)} · ${model.category}`;
}
